export default __webpack_public_path__ + "static/media/Safari (in-app).5d35b053.svg";